import PropTypes from 'prop-types';
import React from 'react';
import { NamespaceConsumer } from '@ux/namespace-component';

/**
 * Render the close button of the tooltip.
 *
 * @param {Object} props Component properties.
 * @returns {ReactElement} button
 * @private
 */
export default class TooltipClose extends NamespaceConsumer {
  render() {
    const { close } = this.props;
    return <button aria-label='close' type='button' className={ this.namespace('close') } onClick={ close } />;
  }
}

/**
 * Property types definition.
 *
 * @enum {Object} propTypes
 * @private
 */
TooltipClose.propTypes = {
  close: PropTypes.func.isRequired
};
